import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  imageUrl: "",
};

const imageManagerModal = createSlice({
  name: "modal",
  initialState,
  reducers: {
    closeImageManagerModal(state) {
      state.isOpen = false;
    },
    openImageManagerModalModal(state) {
      state.isOpen = true;
    },
    setImageUrl(state, action) {
      state.imageUrl = action.payload.imageUrl;
    },
  },
});

export const {
  closeImageManagerModal,
  openImageManagerModalModal,
  setImageUrl,
} = imageManagerModal.actions;

export default imageManagerModal.reducer;
